import { Injectable } from '@angular/core';
import { PromotionDataService } from '../data-services/promotion-data.service';
import { GetAllActiveDealerResponseModel, Promotions } from '../business-entities/promotions-model';
import { GenericResponse } from '../business-entities/generic-response';
@Injectable({
  providedIn: 'root'
})
export class PromotionBusinessService {
  getAllActiveDealerList: GetAllActiveDealerResponseModel[];
  constructor(private service: PromotionDataService) {}
  PromotionId: number
  promotionList: Promotions[];
  promotion: Promotions;
  async getPromotionList(vehicalObj: any): Promise<Promotions[]> {
    await this.service
      .getPromotionList(vehicalObj)
      .then(
        (res: GenericResponse<Array<Promotions>>) => {
          this.promotionList = res.responseObject;
        }
      );
    return this.promotionList;
  }
  deletePromotion(id: number): Promise<any> {
    return this.service.deletePromotion(id);
  }

  activeInactivePromotion(vehicalObj: any): Promise<any> {
    return this.service.activeInactivePromotion(vehicalObj);
  }

  async getPromotionById(promotionId: number) {
    return this.service.getPromotionById(promotionId);
  }

  async addEditPromotion(model: any): Promise<any> {
    return this.service.addEditPromotion(model);
  }
  activeInactiveDealer(dealerId): Promise<any> {
    let model = {
      DealerId: dealerId,
    }
    return this.service.activeInactiveDealer(model);
  }
  async getAllActiveDealer(): Promise<GetAllActiveDealerResponseModel[]> {
    await this.service
      .getAllActiveDealer()
      .then(
        (res:  GenericResponse<Array<GetAllActiveDealerResponseModel>>) => {
          this.getAllActiveDealerList = res.responseObject;
        }
      );
    return this.getAllActiveDealerList;
  }
}
